import React, { useContext, useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { CSidebar, CSidebarBrand, CSidebarNav } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import SimpleBar from 'simplebar-react'
import 'simplebar-react/dist/simplebar.min.css'
// sidebar nav config

import { VendorReducer } from 'shared/redux/reducers/vendor/VendorReducer'
import $ from "jquery";
import { BrowserDetectContext } from 'providers/BrowserEventProvider'
import { ManagerSidebarNav } from './ManagerSidebarNav'
import ManagerSideBarNavData from './ManagerSidebarNavData'

function ManagerSideBar() {
    const { isMobile } = useContext(BrowserDetectContext);
    const sidebar = useRef();
    const dispatch = useDispatch();
    const { sidebarShow, sidebarUnfoldable } = useSelector((state) => ({ sidebarShow: state.vendor.sidebarShow, sidebarUnfoldable: state.vendor.sidebarUnfoldable }));
    const [isVisible, setVisible] = useState(true);

    useEffect(() => {
        sidebar.current?.addEventListener('transitionend', onSidebarTransitionEnd);

        return () => {
            sidebar.current.removeEventListener('transitionend', onSidebarTransitionEnd);
        }
    }, []);

    const onSidebarTransitionEnd = () => {
        let margin = $('.sidebar').outerWidth(true) - $('.sidebar').outerWidth();
        if (margin === 0) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }

    const onSidebarTogglerClick = () => {
        dispatch(VendorReducer.actions.toggleSidebarUnfoldable(!sidebarUnfoldable));
    }


    useEffect(() => {
        setVisible(sidebarShow);
    }, [sidebarShow]);

    useEffect(() => {
        if (isVisible === undefined) {

        } else {
            dispatch(VendorReducer.actions.toggleSideBar(isVisible));
        }
    }, [isVisible]);

    return (
        <CSidebar ref={sidebar} position="fixed" unfoldable={sidebarUnfoldable} visible={isMobile?sidebarShow:true}>
            <CSidebarBrand className="d-none d-md-flex" to="/">
                <div style={{ width: "100%", backgroundColor: "white" }}>
                    <div style={{ width: "90%", height: "100%", padding: "20px" }}>
                        {/* <img src={WorldvapeLogo} style={{width:"150px"}}/> */}
                    </div>
                </div>
            </CSidebarBrand>
            <CSidebarNav>
                <SimpleBar>
                    <ManagerSidebarNav items={ManagerSideBarNavData} />
                </SimpleBar>
            </CSidebarNav>
            {/* <CSidebarToggler className="d-none d-lg-flex" onClick={onSidebarTogglerClick} /> */}
        </CSidebar>
    )
}

// export default React.memo(VendorSidebar);
export default ManagerSideBar;